import './Loading.scss';
import React, { Component } from "react";
import MyContext from '../MyContext.jsx';
import ekatralogo from "./ekatralogo.svg"

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <MyContext.Consumer>
        {context => (
          <div className="loading_container" style={{ display: context.show_loading ? 'block' : 'none' }}>
            <div className={`loading_symbol ${context.show_loading ? 'rotate' : ''}`}>
              <img src={ekatralogo} />
            </div>
          </div>
        )}
      </MyContext.Consumer>
    );
  }
}

export default Loading;
